/* Kontakt- und Melde-Adressen an einer Stelle — Footer, Impressum und
   Fehlerseite lesen von hier. */
export const CONTACT_EMAIL = 'contact@nordbyte.io'

/* Meldungen rechtswidriger Inhalte gehen an die Rechtsadresse, nicht an den
   allgemeinen Support (CONTACT_EMAIL). */
export const REPORT_EMAIL = 'legal@clarify.bot'

/* Meldeweg für rechtswidrige Inhalte (Art. 16 DSA) — vorerst per E-Mail, das
   Melde-Tool folgt. Der vorbefüllte Text fragt ab, was eine Meldung braucht:
   Fundort, Begründung, Kontakt und die Erklärung, dass die Angaben stimmen. */
const REPORT_BODY = [
  'Where is the content? (message link, server ID or transcript URL)',
  '',
  '',
  'Why do you believe it is illegal?',
  '',
  '',
  'Your name and email address:',
  '',
  '',
  'I confirm that the information in this report is accurate and complete to the best of my knowledge.'
].join('\r\n')

export const REPORT_MAILTO
  = `mailto:${REPORT_EMAIL}?subject=${encodeURIComponent('Clarify: content report')}&body=${encodeURIComponent(REPORT_BODY)}`
